import { useTranslation } from 'react-i18next'
import { useGetUsersListByCourse } from '@BUP/hooks/Enrollments/useGetUsersListByCourse'
import BupSpinner from '@BUP/components/Loading/Spinner'
import ButtonComponent from '@BUP/components/Generics/Button'
import { STUDENT } from '@BUP/constants'
import styles from './active-survey-button.module.scss'

const ActiveSurveyButton = ({
  setSelectedSurvey,
  setStateActiveSurveyModal,
  sociogram,
  survey
}) => {
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.data.sociogram.activeSociogramEce'
  })

  const { courses } = survey
  const courseId = courses[0].id
  const { usersList, isLoadingUsers } = useGetUsersListByCourse(
    courseId,
    STUDENT
  )
  const handleShowActiveSurveyModal = (survey) => {
    setStateActiveSurveyModal(true)
    setSelectedSurvey(survey)
  }

  if (isLoadingUsers) return <BupSpinner size='small' />
  if (!usersList || usersList.length === 0) {
    return <p>{t('table.emptyCourseText')}</p>
  }

  return (
    <div
      className={styles.actions_cell_wrapper}
      data-test='cell-wrapper-active-button'
    >
      <ButtonComponent
        buttonText={`${t('table.activateButton')}`}
        colorType='primary'
        block
        bold={false}
        disabled={sociogram.isDone}
        onClick={() => handleShowActiveSurveyModal(survey)}
      />
    </div>
  )
}

export default ActiveSurveyButton
